import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const HomeCityOutlineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20' {...props} ref={ref}>
        <path
            d='M8.33 1.67v1.88L10 4.66V3.33h8.33v12.5h-4.16v1.67H20V1.67H8.33Zm-2.08 2.5L0 8.33v9.17h12.5V8.33L6.25 4.17Zm5.42.83v.78l1.34.89h.32V5h-1.66ZM15 5v1.67h1.67V5H15ZM6.25 6.25l4.58 2.92v6.66h-2.5v-5H4.17v5h-2.5V9.17l4.58-2.92ZM15 8.33V10h1.67V8.33H15Zm0 3.34v1.66h1.67v-1.66H15Z'
            fill='currentColor'
        />
    </svg>
));
